import s from './styles.scss';
import cx from 'classnames';
import { enums as e } from 'edrolo-ui';

export interface CircleProps {
  numerator: number;
  denominator: number;
  color?: e.ColorHue;
  size?: e.Size;
  className?: string;
}

export const Circle = ({
  numerator,
  denominator,
  color = e.ColorHue.GREEN,
  className,
  size = e.Size.MEDIUM,
}: CircleProps) => {
  const strokeWidth = 18;
  const radius = 50 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const percentage = denominator <= 0 ? 0 : (numerator / denominator) * 100;
  const portion = (percentage / 100) * circumference;

  return (
    <div
      className={cx(s.progressCircle, s[color], s[size], className)}
      aria-label="progress-status"
      data-test="progress-status"
    >
      <svg viewBox="0 0 100 100" fill="none">
        <circle
          className={s.track}
          cx="50"
          cy="50"
          r={radius}
          strokeWidth={strokeWidth}
        />
        {portion > 0 && (
          <circle
            className={s.fill}
            cx="50"
            cy="50"
            r={radius}
            strokeWidth={strokeWidth}
            strokeDasharray={`${portion} ${circumference}`}
          />
        )}
      </svg>
    </div>
  );
};
